import Spline from '@splinetool/react-spline';

export default function LobbyScene() {
  return (
    <Spline scene="https://prod.spline.design/F1u4rsWKOo1mPZCT/scene.splinecode" />
  );
}
